import api from '../api';

const UNCENSORED_NEWS_URL = 'https://brighto.io/getjson.asp';

export const UNCENSORED_NEWS_FEED_FETCH_REQUEST = 'UNCENSORED_NEWS_FEED_FETCH_REQUEST';
export const UNCENSORED_NEWS_FEED_FETCH_SUCCESS = 'UNCENSORED_NEWS_FEED_FETCH_SUCCESS';
export const UNCENSORED_NEWS_FEED_FETCH_FAIL = 'UNCENSORED_NEWS_FEED_FETCH_FAIL';

export const UNCENSORED_NEWS_FEED_EXPAND_REQUEST = 'UNCENSORED_NEWS_FEED_EXPAND_REQUEST';
export const UNCENSORED_NEWS_FEED_EXPAND_SUCCESS = 'UNCENSORED_NEWS_FEED_EXPAND_SUCCESS';
export const UNCENSORED_NEWS_FEED_EXPAND_FAIL = 'UNCENSORED_NEWS_FEED_EXPAND_FAIL';
export const UNCENSORED_NEWS_FEED_EXPAND_END_SUCCESS = 'UNCENSORED_NEWS_FEED_EXPAND_END_SUCCESS';

const defaultAxiosConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    accept: 'application/json',
  },
  data: {},
  transformRequest: (data, headers) => {
    delete headers['X-CSRF-Token'];
    delete headers.Authorization;
  },
  crossDomain: true,
};

const decodeHtml = (html) => {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const processArticle = (page, article) => {
  return { ...article, article: page + article.article, headline: decodeHtml(article.headline) };
};

export function fetchArticles() {
  return (dispatch, getState) => {
    dispatch(fetchArticlesRequest());

    const page = getState().getIn(['uncensored_news_feed', 'page']);

    api().get(UNCENSORED_NEWS_URL, { ...defaultAxiosConfig, params: { page } })
      .then(response => {
        let resp_data = response.data;
        if (typeof resp_data === 'string') {
          // Step 1: Remove trailing commas
          const cleanedJson = resp_data
            .replace(/,(\s*[}\]])/g, '$1')
            .replace(/^\uFEFF/, '');

          // Step 2: Fix unescaped quotes within string values
          let result = '';
          let inString = false;
          let isKey = false;

          for (let i = 0; i < cleanedJson.length; i += 1) {
            const char = cleanedJson[i];
            const prevChar = i > 0 ? cleanedJson[i - 1] : '';

            if (char === '"' && prevChar !== '\\') {
              if (!inString) {
                // Starting a string
                inString = true;
                // Check if this is a key (followed by colon after closing quote)
                let j = i + 1;
                while (j < cleanedJson.length && cleanedJson[j] !== '"') {
                  j += 1;
                }
                if (j < cleanedJson.length) {
                  j += 1; // Skip closing quote
                  while (j < cleanedJson.length && /\s/.test(cleanedJson[j])) {
                    j += 1;
                  }
                  isKey = cleanedJson[j] === ':';
                }
                result += char;
              } else if (isKey) {
                // End of key string
                inString = false;
                isKey = false;
                result += char;
              } else {
                // We're in a value string - check if this is the actual end
                // Look ahead to see if next non-whitespace is : or , or } or ]
                let j = i + 1;
                while (j < cleanedJson.length && /\s/.test(cleanedJson[j])) {
                  j += 1;
                }
                const nextMeaningful = cleanedJson[j];

                if (nextMeaningful === ',' || nextMeaningful === '}' || nextMeaningful === ']') {
                  // This is the closing quote
                  inString = false;
                  result += char;
                } else {
                  // This is an unescaped quote within the value
                  result += '\\"';
                }
              }
            } else {
              result += char;
            }
          }

          resp_data = JSON.parse(result);
        }
        dispatch(fetchArticlesSuccess(resp_data.articles[0].articles.map(
          processArticle.bind(null, page))));
      })
      .catch(error => {
        dispatch(fetchArticlesFail(error));
      });
  };
}

export function expandArticles() {
  return (dispatch, getState) => {
    const page = getState().getIn(['uncensored_news_feed', 'page']) + 1;

    dispatch(expandArticlesRequest());

    api().get(UNCENSORED_NEWS_URL, { ...defaultAxiosConfig, params: { page } })
      .then(response => {
        let resp_data = response.data;
        if (typeof resp_data === 'string') {
          // Step 1: Remove trailing commas
          const cleanedJson = resp_data
            .replace(/,(\s*[}\]])/g, '$1')
            .replace(/^\uFEFF/, '');

          // Step 2: Fix unescaped quotes within string values
          let result = '';
          let inString = false;
          let isKey = false;

          for (let i = 0; i < cleanedJson.length; i += 1) {
            const char = cleanedJson[i];
            const prevChar = i > 0 ? cleanedJson[i - 1] : '';

            if (char === '"' && prevChar !== '\\') {
              if (!inString) {
                // Starting a string
                inString = true;
                // Check if this is a key (followed by colon after closing quote)
                let j = i + 1;
                while (j < cleanedJson.length && cleanedJson[j] !== '"') {
                  j += 1;
                }
                if (j < cleanedJson.length) {
                  j += 1; // Skip closing quote
                  while (j < cleanedJson.length && /\s/.test(cleanedJson[j])) {
                    j += 1;
                  }
                  isKey = cleanedJson[j] === ':';
                }
                result += char;
              } else if (isKey) {
                // End of key string
                inString = false;
                isKey = false;
                result += char;
              } else {
                // We're in a value string - check if this is the actual end
                // Look ahead to see if next non-whitespace is : or , or } or ]
                let j = i + 1;
                while (j < cleanedJson.length && /\s/.test(cleanedJson[j])) {
                  j += 1;
                }
                const nextMeaningful = cleanedJson[j];

                if (nextMeaningful === ',' || nextMeaningful === '}' || nextMeaningful === ']') {
                  // This is the closing quote
                  inString = false;
                  result += char;
                } else {
                  // This is an unescaped quote within the value
                  result += '\\"';
                }
              }
            } else {
              result += char;
            }
          }

          resp_data = JSON.parse(result);
        }
        if (resp_data.articles?.[0]) {
          dispatch(expandArticlesSuccess(resp_data.articles[0].articles.map(
            processArticle.bind(null, page)), page));
        } else {
          dispatch(expandArticlesEndSuccess());
        }
      })
      .catch(error => {
        dispatch(expandArticlesFail(error));
      });

  };
}

export function fetchArticlesRequest() {
  return {
    type: UNCENSORED_NEWS_FEED_FETCH_REQUEST,
    skipLoading: true,
  };
}

export function fetchArticlesSuccess(articles) {
  return {
    type: UNCENSORED_NEWS_FEED_FETCH_SUCCESS,
    articles,
    skipLoading: true,
  };
}

export function fetchArticlesFail(error) {
  return {
    type: UNCENSORED_NEWS_FEED_FETCH_FAIL,
    error,
    skipLoading: true,
  };
}

export function expandArticlesRequest() {
  return {
    type: UNCENSORED_NEWS_FEED_EXPAND_REQUEST,
  };
}

export function expandArticlesSuccess(articles, page) {
  return {
    type: UNCENSORED_NEWS_FEED_EXPAND_SUCCESS,
    articles,
    page,
  };
}

export function expandArticlesFail(error) {
  return {
    type: UNCENSORED_NEWS_FEED_EXPAND_FAIL,
    error,
  };
}

export function expandArticlesEndSuccess() {
  return {
    type: UNCENSORED_NEWS_FEED_EXPAND_END_SUCCESS,
  };
}
